export class Product {
  constructor(
    public indskr_productid: String,
    public indskr_productname: String,
    public isChecked?: boolean
  ) {}
}
